import { avoidBreakInside } from '@provider/print';
import { cell, cellContent } from './_task.in-table.style.js';
import { InTableCheckboxInput } from './input.checkbox.js';
import { InTableFractionInput } from './input.fraction.js';
import { InTableImageInput } from './input.image.js';
import { InTableReadonlyInput } from './input.readonly.js';
import { InTableTextInput } from './input.text.js';
import { jsx } from 'react/jsx-runtime';

function Row(props) {
  return /*#__PURE__*/jsx("tr", {
    ...avoidBreakInside(),
    children: props.inputs.map((input, index) => /*#__PURE__*/jsx("td", {
      className: cell,
      children: /*#__PURE__*/jsx("span", {
        className: cellContent,
        "data-alignment": input.nodeType === "in-table-readonly" ? input.style.align : "Center",
        children: /*#__PURE__*/jsx(Input, {
          input: input,
          taskEntryKey: props.taskEntryKey
        })
      })
    }, index))
  });
}
function Input(props) {
  switch (props.input.nodeType) {
    case "in-table-checkbox-input":
      return /*#__PURE__*/jsx(InTableCheckboxInput, {
        ...props,
        input: props.input
      });
    case "in-table-fraction-input":
      return /*#__PURE__*/jsx(InTableFractionInput, {
        ...props,
        input: props.input
      });
    case "in-table-text-input":
      return /*#__PURE__*/jsx(InTableTextInput, {
        ...props,
        input: props.input
      });
    case "in-table-image":
      return /*#__PURE__*/jsx(InTableImageInput, {
        input: props.input
      });
    case "in-table-readonly":
      return /*#__PURE__*/jsx(InTableReadonlyInput, {
        input: props.input
      });
    default:
      return null;
  }
}

export { Row };
//# sourceMappingURL=molecule.row.js.map
